<template>
  <div class="loading-container">
    <div class="loading-bar" />
  </div>
</template>

<style>
.loading-container {
  display: inline-block;
  width: 200px;
  height: 12px;
  border: 3px solid lightgray;
  border-radius: 10px;
  overflow: hidden;
}

.loading-bar {
  width: 0%;
  height: 100%;
  background: rgb(37, 138, 186);
  animation: fill 1s ease-in-out infinite;
}

@keyframes fill {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
</style>
